<div class="custom-form" [formGroup]="form">
  <mat-form-field class="w-full" [class.mat-form-field-with-icon]="store.validatedChannelIcon$()">
    <input
      #channelInput
      matInput
      cdkFocusInitial
      formControlName="url"
      [placeholder]="placeholder() ?? ('shared.url' | translate)"
    />

    @if (store.createChannelLoading$() || store.validateChannelLoading$()) {
      <app-dots-spinner matSuffix />
    } @else if (store.validatedChannelPlatform$()) {
      <app-icon src="/icons/circle-check.svg" class="w-6 h-6" color="var(--shikenso-success-base)" matSuffix />
    }

    @if (store.validatedChannelIcon$()) {
      <img [src]="store.validatedChannelIcon$()" alt="Channel icon" class="w-8 h-8 rounded-full mr-1" matPrefix />
    }

    <mat-error [control]="form.get('url')" [customErrorMessage]="store.error$() || errorMessage() || ''">
      @if (store.errorCreatorExists$()) {
        <button
          *hasPermission="[EPermissions.creatorReadOwn]"
          mat-icon-button
          type="button"
          class="mat-secondary-transparent-button-color mat-tiny-icon-button top-1 !p-0"
          (click)="onOpenErrorCreatorClick()"
        >
          <app-icon src="/icons/launch.svg" alt="Open creator in new tab" [size]="16" />
        </button>
      }
    </mat-error>
  </mat-form-field>

  <div class="flex items-center gap-2 mt-3">
    <p class="text-sm text-shikenso-purple-base-60">
      {{ 'components.addPlatformInput.allowedPlatforms' | translate }}:
    </p>

    @if (store.validPlatforms$() === null) {
      <div class="flex items-center gap-1">
        @for (i of [1, 2, 3]; track i) {
          <div class="h-6 w-6 flex items-center justify-center">
            <ngx-skeleton-loader class="h-4" [theme]="{ width: '16px', height: '16px', 'border-radius': '8px' }" />
          </div>
        }
      </div>
    } @else {
      <app-social-badge-list
        [badgeData]="allowedPlatforms()"
        [showTooltip]="true"
        [shownIconsCount]="allowedPlatforms().length"
      />
    }
  </div>
</div>
